export const STALE_TIME = {
  STATIC: 30 * 60 * 1000,      // 30 minutes - user profile, settings
  FINANCIAL: 5 * 60 * 1000,    // 5 minutes - balances, allocations
  REALTIME: 60 * 1000,         // 1 minute - prices, charts (with WebSocket support)
  CRITICAL: 30 * 1000,         // 30 seconds - KYC status, accounts
}